// eslint-disable-next-line no-unused-vars
import React from "react";
/** @jsx jsx */
import { jsx } from "theme-ui";
import { Themed } from "@theme-ui/mdx";

const PageSectionHeading = ({title}) => {
  return (<>
    <Themed.h1 sx={{
      textAlign: "center",
      mt: 3
    }}>
      {title}
    </Themed.h1>
    <hr sx={{
      height: "2px",
      width: "100px",
      mt: 0,
      mb: [8, 8, 9],
      borderStyle: "none",
      background: (theme) => `linear-gradient(
        to right,
        ${theme.colors.primary},
        ${theme.colors.accent}
      )`
    }}/>
  </>);
};

export default PageSectionHeading;